import { render, staticRenderFns } from "./HaabControls.vue?vue&type=template&id=1521a15e&scoped=true"
import script from "./HaabControls.vue?vue&type=script&lang=js"
export * from "./HaabControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521a15e",
  null
  
)

export default component.exports